import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { PlanTypes } from "../../../../../types/plan";

export const InvoicesWrapper = styled.div`
	padding-top: 24px;
`;

const InvoicesTableChipStyle = css`
	padding: 5px 10px;
	font-size: 11px;
	font-weight: bold;
	border-radius: 4px;
`;
type StatusChipTypes = "ing" | "end";

interface InvoicesTableTypeChipProps {
	type: PlanTypes;
}

interface InvoicesTableStatusChipProps {
	status: StatusChipTypes;
}

export const TypeChipColors: Record<PlanTypes, string> = {
	custom: "#947332",
	basic: "#326594",
	free: "#6A6A6A",
	welcome: "#6A6A6A",
};

export const TypeChipBackgroundColors: Record<PlanTypes, string> = {
	custom: "#FFF9E6",
	basic: "#E6FCFF",
	free: "#DFDFDF",
	welcome: "#DFDFDF",
};

export const StatusChipColors: Record<StatusChipTypes, string> = {
	end: "#6A6A6A",
	ing: "#403294",
};

export const StatusChipBackgroundColors: Record<StatusChipTypes, string> = {
	end: "#DFDFDF",
	ing: "#EAE6FF",
};

export const InvoicesTableTypeChip = styled.span<InvoicesTableTypeChipProps>`
	${InvoicesTableChipStyle}
	${({ type }) => css`
		color: ${TypeChipColors[type]};
		background-color: ${TypeChipBackgroundColors[type]};
	`}
`;

export const InvoicesTableStatusChip = styled.span<InvoicesTableStatusChipProps>`
	${InvoicesTableChipStyle}
	${({ status }) => css`
		color: ${StatusChipColors[status]};
		background-color: ${StatusChipBackgroundColors[status]};
	`}
`;

export const InvoicesTableUsageWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const InvoicesTableUsageTitle = styled.span`
	font-size: 14px;
	line-height: 2rem;
	color: #545351;
	margin-right: 32px;
`;

interface InvoiceTableUsageBarProps {
	fill: number;
}

export const InvoiceTableUsageBar = styled.div`
	width: 50px;
	height: 8px;
	background-color: #e1e1e1;
	position: relative;
`;

export const InvoiceTableUsageBarProgress = styled.div<InvoiceTableUsageBarProps>`
	width: ${({ fill }) => fill}%;
	height: 8px;
	padding: 0;
	text-align: center;
	background-color: #7000ff;
`;
